import React from "react";
import Image from "@/components/Atoms/Image";
import { FullBackgroundImage } from "@/components/Molecules/ImageCard";
import HeroFeaturedZoomImage from "./HeroFeaturedZoomImage";
import styles from "./HeroFeaturedGridMobile.module.scss";

interface HeroFeaturedGridMobileProps {
  id: string;
  backgroundStyle: React.CSSProperties;
  backgroundHex: string;
  isContain: boolean;
  overlay: React.ReactNode;
  backgroundHero: React.ReactNode;
  copyCard: React.ReactNode;
  imageColData: any;
  featuredImage: any;
  formColumn?: React.ReactNode;
  textAlignment?: string | null;
  addZoom?: boolean;
  zoomIconColor?: { hex?: string };
  isReducedLayout?: boolean;
}

export default function HeroFeaturedGridMobile({
  id,
  backgroundStyle,
  backgroundHex,
  isContain,
  overlay,
  backgroundHero,
  copyCard,
  imageColData,
  featuredImage,
  formColumn,
  addZoom = false,
  zoomIconColor,
  isReducedLayout = false,
}: HeroFeaturedGridMobileProps) {
  const showZoom = Boolean(addZoom && featuredImage);
  const useReducedLayout = isReducedLayout || showZoom;

  const backgroundLayer = useReducedLayout ? (
    <div className={styles.zoomBackground}>
      {overlay}
      {backgroundHero}
    </div>
  ) : (
    <>
      {overlay}
      {!isContain && backgroundHero}
    </>
  );

  return (
    <div
      className={`${styles.shell} ${useReducedLayout ? styles.shellZoom : ""}`}
      id={id}
      style={backgroundStyle}
    >
      {backgroundLayer}
      <div className={styles.stage}>
        {imageColData && (
          <figure
            className={`${styles.imageCol} ${useReducedLayout ? styles.imageColZoom : ""}`}
            aria-hidden={!imageColData}
          >
            {showZoom ? (
              <HeroFeaturedZoomImage
                image={featuredImage}
                iconColor={zoomIconColor}
                imageClassName={`relative mx-auto ${styles.imageAssetZoom}`}
                buttonClassName="right-[5rem] md:right-[25%]"
              />
            ) : isContain ? (
              <FullBackgroundImage data={imageColData} position="Contain" />
            ) : (
              featuredImage && (
                <Image
                  data={featuredImage}
                  className={`relative ${styles.imageAsset}`}
                  objectFit="contain"
                />
              )
            )}
          </figure>
        )}
        <div
          className={styles.gradient}
          style={
            { "--hero-bg-color": backgroundHex } as React.CSSProperties
          }
          aria-hidden
        />
        <div className={styles.copyWrap}>
          <div className={styles.copyCol}>{copyCard}</div>
        </div>
      </div>
      {formColumn}
    </div>
  );
}
